import {FETCH_FREQ, FETCH_FREQ_SUCCESS, FETCH_FREQ_ERROR, UPDATE_FREQ, UPDATE_FREQ_SUCCESS, UPDATE_FREQ_ERROR, RESET_UPDATE_FREQ} from "constants/ActionTypes";

export const fetchFreq = () => {
  return {
    type: FETCH_FREQ,
  }
};

export const fetchFreqSuccess = (freqList) => {
  return {
    type: FETCH_FREQ_SUCCESS,
    payload: freqList,
  }
};

export const fetchFreqError = (error) => {
  return {
    type: FETCH_FREQ_ERROR,
    payload: error
  }
};

export const updateFreq = (params) => {
  return {
    type: UPDATE_FREQ,
    params,
  }
};

export const updateFreqSuccess = (payload) => {
  return {
    type: UPDATE_FREQ_SUCCESS,
    payload,
  }
};

export const updateFreqError = (error) => {
  return {
    type: UPDATE_FREQ_ERROR,
    error,
  }
};

export const resetUpdateFreq = () => {
  return {
    type: RESET_UPDATE_FREQ,
  }
};
